import React from "react";
import Footer from "../../components/footer";
import Header from "../../components/header";

function NotFoundPage() {
  return (
    <div>
      <Header />
      <br />
      <br />
      <br />
      <br />
      <br />
      <h1 className="mx-auto d-flex justify-content-center">
        Oops Sorry Not Found
      </h1>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <Footer />
    </div>
  );
}

export default NotFoundPage;
